import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import { useEffect } from "react";

export default function InitalLoadPage(props) {
    const { branding } = useModel();
    const navigate = useRoute();

    const route = branding.options.standalone_bill_discovery_rxp22 === "true" 
        ? "/welcome"
        : "/paybills";

    useEffect(() => navigate(route));

    return <></>;
}